import React from 'react';

const Progress = ({ value = 0, className = '' }) => {
  // Ensure value is between 0 and 100
  const clampedValue = Math.min(100, Math.max(0, value));

  return (
    <div className={`relative h-2 w-full overflow-hidden rounded-full bg-gray-200 ${className}`}>
      <div
        className="h-full w-full flex-1 bg-primary transition-all duration-300" // Use your primary color from tailwind.config.js
        style={{ transform: `translateX(-${100 - clampedValue}%)` }}
      />
    </div>
  );
};

export default Progress;